import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  BrokerList,
  BrokerSchedulesResponse,
  BrokerSlotsResponse,
  NewVisit,
  ServerResponse,
} from '@models';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BookVisitService {
  public response: Subject<boolean> = new Subject<boolean>();

  private broker = environment.BROKER;
  private clientManage = environment.CLIENT_MANAGE;

  constructor(private readonly http: HttpClient) {}

  /**
   * Show book visit modal
   */
  public continue(): void {
    this.response.next(true);
  }

  /**
   * Post get all brokers
   */
  public getBrokers(): Observable<BrokerList[]> {
    const path = this.broker.BROKER;
    return this.http.get<ServerResponse>(path).pipe(map((e) => e.response));
  }

  /**
   * Close book visit modal
   */
  public close(): void {
    this.response.next(false);
  }

  public addVisit(
    clientId: string,
    data: NewVisit
  ): Observable<ServerResponse> {
    const path = this.clientManage.NEW_VISIT.replace('{clientId}', clientId);
    return this.http.patch<ServerResponse>(path, data);
  }

  public getBrokerSchedules(
    brokerId: string
  ): Observable<BrokerSchedulesResponse> {
    const path = this.broker.SCHEDULES.replace('{brokerId}', brokerId);
    return this.http.get<BrokerSchedulesResponse>(path);
  }

  public getBrokerSlots(
    brokerId: string,
    date: string
  ): Observable<BrokerSlotsResponse> {
    const path = this.broker.SLOTS.replace('{brokerId}', brokerId);
    return this.http.get<BrokerSlotsResponse>(path, {
      params: {
        brokerId,
        date,
      },
    });
  }
}
